<template>
  <section class="logo-container">
    <span class="logo-icon">🎬</span>
    <span class="slogan" v-if="!collapsed">ShootDay</span>
  </section>
</template>
<script setup lang="ts">
import { useSettingsStore } from '@/stores/settings'

withDefaults(
  defineProps<{
    collapsed?: boolean
    show_admin?: boolean
  }>(),
  {
    show_admin: true,
  },
)
const size = 181 / 2

const settings_store = useSettingsStore()
</script>
<style scoped>
.big-logo-enter-active,
.big-logo-leave-active {
  transition: opacity 0.25s ease-in;
}

.big-logo-enter-from,
.big-logo-leave-to {
  opacity: 0;
  transform: translateX(-100px);
}
.small-logo-enter-active,
.small-logo-leave-active {
  transition: all 0.25s ease-in;
}

.small-logo-enter-from,
.small-logo-leave-to {
  opacity: 0;
  transform: translateX(-100px);
}

.logo-container {
  display: inline-flex;
  position: relative;
  align-items: center;
  padding-left: 23px;
  height: 74px;
}
.logo-icon {
  font-size: 32px;
  color: var(--sidebar-text);
}
.slogan {
  font-size: 24px;
  font-weight: 600;
  padding-left: 10px;
}
</style>
